import { fetcher } from '@commenda/utils';

export type TUpdateCompanyHandler = {
  name?: string;
  meetingCalendarLink?: string;
  avatar?: string;
};

export async function updateCompanyHandler(
  userId: string,
  data: TUpdateCompanyHandler
) {
  try {
    const res = await fetcher(`user/${userId}`, {
      method: 'POST',
      body: data,
    });

    return res;
  } catch (err) {
    console.error(err);
    throw err;
  }
}
